<mat-form-field class="wrapper" appearance="outline">
  <mat-label class="date-label"
    ><span>{{ label }}</span></mat-label
  >
  <input
    [id]="zipYiElement.GiftingScheduledDate"
    matInput
    readonly
    class="date-input"
    [matDatepickerFilter]="dateFilter"
    [matDatepicker]="picker"
    [value]="value"
    (dateChange)="onChangeEvent($event)"
    (click)="picker.open()"
  />
  <mat-hint>{{ hint }}</mat-hint>
  <mat-datepicker-toggle [for]="picker" class="date-picker-toggle"> </mat-datepicker-toggle>
  <mat-datepicker #picker [calendarHeaderComponent]="customizedHeader"></mat-datepicker>
</mat-form-field>
